import { render } from "./ClientAccount.vue?vue&type=template&id=da545f36&scoped=true"
import script from "./ClientAccount.vue?vue&type=script&lang=js"
export * from "./ClientAccount.vue?vue&type=script&lang=js"

import "./ClientAccount.vue?vue&type=style&index=0&id=da545f36&scoped=true&lang=css"

import exportComponent from "/Users/david/Desktop/projects/Realgestion/rg-massive-camoruco/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da545f36"]])

export default __exports__